<template>
  <div class="field">
    <input
      class="field__input"
      :type="type"
      :name="name"
      :placeholder="label"
      :value="value"
      :disabled="disabled"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
    />
    <label :for="name" class="field__label">{{ label }}</label>
    <button
      v-if="button"
      @click.prevent="onClick"
      class="button button__rounded"
      :class="{ button__blue: blue }"
    >
      {{ button }}
    </button>
    <span v-if="info" class="field__info">{{ info }}</span>
    <span v-if="errors" class="field__error">{{ errors }}</span>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    button: {
      type: String,
      default: null
    },
    blue: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    errors: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    }
  }
};
</script>

<style lang="scss">
.field {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
  &__input {
    width: 100%;
    padding: 1em 0 5px;
    border: 0;
    border-radius: 0;
    outline: 0;
    box-shadow: none;
    font-size: 1.6rem;
    color: black;
    background-color: transparent;
    border-bottom: 1px solid $gray;
    &::placeholder {
      opacity: 0;
      transition: $transition;
    }
    &:placeholder-shown:not(:focus)::placeholder {
      opacity: 0;
    }
    &:placeholder-shown:not(:focus) + label {
      font-size: 1.6rem;
      transform: translateY(15px);
      color: $gray;
    }
    &:focus {
      border-bottom: 1px solid $lightred;
    }
    &:disabled {
      color: #aaa;
      cursor: not-allowed;
    }
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-10px);
    font-size: 1.4rem;
    pointer-events: none;
    color: $lightred;
    transition: $transition;
  }
  &__info {
    display: none;
    @include bp(sm) {
      display: block;
    }
  }
  &__error {
    margin-top: 0.5em;
    color: $error;
    font-size: 1.4rem;
  }
}
</style>
